import { render, staticRenderFns } from "./TableMenuSpendings.vue?vue&type=template&id=6a9424aa&scoped=true&"
import script from "./TableMenuSpendings.vue?vue&type=script&lang=js&"
export * from "./TableMenuSpendings.vue?vue&type=script&lang=js&"
import style0 from "./TableMenuSpendings.vue?vue&type=style&index=0&id=6a9424aa&prod&lang=sass&scoped=true&"
import style1 from "./TableMenuSpendings.vue?vue&type=style&index=1&id=6a9424aa&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9424aa",
  null
  
)

export default component.exports